import { render, staticRenderFns } from "./MultipleCheckboxFilterAdmin.vue?vue&type=template&id=455f5131&lang=pug&"
import script from "./MultipleCheckboxFilterAdmin.vue?vue&type=script&lang=js&"
export * from "./MultipleCheckboxFilterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports